function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React, { Fragment } from 'react';
import { withTheme } from 'styled-components';
import { finectAPI } from '@finect/front-utils/finectAPI';
import { timeSince } from '@finect/front-utils/timeSince';
import { EntryEditor } from '@finect/tabular-draft-editor';
import { isProfileAdviser } from '@finect/front-core/Profiles';
import { Author } from '../../Author';
import { getReviewPath } from '../utils';
import { EditButton, DeleteButton, SaveButton, CancelButton } from './../../EditionActions';
import { decorators } from './../decorators';
import { Editor } from './Editor';
import { Stars, Feature } from './../../Stars';
import { Toolbar } from './Toolbar/Toolbar';
import { Comments } from './../Comments/Comments';
import { models } from './../utils/models';
import { likeReview, unlikeReview } from './../utils/actions';
import { Inner, Header, PublishDate, ProfessionalBadge, Footer, Entry, Meta, Body, Features, ReviewFeature, FeatureName, FeatureValue, ReviewTitle, Deleted } from './partials';
var ReviewCard = function (_React$Component) {
  _inherits(ReviewCard, _React$Component);
  var _super = _createSuper(ReviewCard);
  function ReviewCard() {
    var _this;
    _classCallCheck(this, ReviewCard);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "bodyEditor", void 0);
    _defineProperty(_assertThisInitialized(_this), "titleEditor", void 0);
    _defineProperty(_assertThisInitialized(_this), "state", {
      review: _this.props.review,
      collapsed: _this.props.collapsed,
      liked: false,
      likes: _this.props.review.socialStats.likes,
      editing: false,
      deleted: false,
      title: _this.props.review.title,
      body: _this.props.review.body,
      score: _this.props.review.score,
      features: []
    });
    _defineProperty(_assertThisInitialized(_this), "handleBodyUpdate", function (body) {
      _this.setState({
        body: body
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleScoreChange", function (score) {
      _this.setState({
        score: score
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleEditBtn", function () {
      _this.setState({
        editing: true
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleCancelBtn", function () {
      _this.setState({
        review: _this.props.review,
        editing: false
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleSaveBtn", function () {
      var title = _this.props.review.title;
      var payload = {
        title: title,
        score: _this.state.score,
        body: {
          metadata: _this.state.body ? _this.state.body.body : {},
          text: _this.state.body ? _this.state.body.plain_text : ''
        }
      };
      finectAPI({
        version: 'v4',
        path: "contents/reviews/".concat(_this.state.review.id),
        method: 'PATCH',
        body: payload,
        onSuccess: function onSuccess(_ref) {
          var data = _ref.data;
          _this.setState({
            editing: false,
            review: models.review(data.review, data.authors)
          });
        }
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleDeleteBtn", function () {
      if (confirm('¿Estás seguro que quieres borrar tu review?')) {
        finectAPI({
          version: 'v4',
          path: "contents/reviews/".concat(_this.state.review.id),
          method: 'DELETE',
          onSuccess: function onSuccess(_ref2) {
            var data = _ref2.data;
            _this.setState({
              deleted: true
            });
          }
        });
      }
    });
    _defineProperty(_assertThisInitialized(_this), "handleLike", function () {
      _this.state.liked ? _this.fetchUnlike() : _this.fetchLike();
      _this.setState({
        liked: !_this.state.liked,
        likes: !_this.state.liked ? _this.state.likes + 1 : _this.state.likes - 1
      });
    });
    return _this;
  }
  _createClass(ReviewCard, [{
    key: "fetchIsLiked",
    value: function fetchIsLiked() {
      var _this2 = this;
      var me = this.props.me;
      if (me && me.isLoggedIn) {
        finectAPI({
          version: 'v4',
          path: "users/me/likes/reviews/".concat(this.state.review.id),
          method: 'GET',
          onSuccess: function onSuccess(_ref3) {
            var data = _ref3.data;
            _this2.setState({
              liked: data.me === 'like'
            });
          }
        });
      }
      this.setState({
        liked: false
      });
    }
  }, {
    key: "fetchLike",
    value: function fetchLike() {
      likeReview(this.state.review.id);
    }
  }, {
    key: "fetchUnlike",
    value: function fetchUnlike() {
      unlikeReview(this.state.review.id);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this3 = this;
      finectAPI({
        version: 'v4',
        path: "contents/catalog/features",
        method: 'GET',
        onSuccess: function onSuccess(_ref4) {
          var data = _ref4.data;
          _this3.setState({
            features: models.reviewFeatures(data)
          });
        }
      });
      this.fetchIsLiked();
    }
  }, {
    key: "render",
    value: function render() {
      var _review$author,
        _this4 = this;
      var _this$props = this.props,
        _this$props$withEntit = _this$props.withEntityCard,
        withEntityCard = _this$props$withEntit === void 0 ? false : _this$props$withEntit,
        review = _this$props.review,
        me = _this$props.me,
        theme = _this$props.theme,
        product = _this$props.product;
      var isAdviser = isProfileAdviser(review.author);
      var isHighlighted = (_review$author = review.author) === null || _review$author === void 0 ? void 0 : _review$author.isHighlighted;
      var liked = this.state.liked;
      var isOwn = me && me.id === review.author.id;
      var path = getReviewPath(theme, _objectSpread(_objectSpread({}, product.entity), {
        subtype: product.subtype
      }), review, this.props.tag);
      if (this.state.deleted) {
        return React.createElement(Fragment, null, React.createElement(Deleted, null, React.createElement("p", null, "Has borrado tu review correctamente")));
      }
      return React.createElement(Inner, null, isAdviser || isHighlighted ? React.createElement(ProfessionalBadge, {
        pro: isAdviser,
        isHighlighted: isHighlighted
      }, isHighlighted ? 'Experto del mes' : 'Review profesional') : '', React.createElement(Entry, {
        isAdviser: isAdviser,
        isHighlighted: isHighlighted
      }, React.createElement(Header, null, React.createElement(Author, {
        main: false,
        withEntityCard: withEntityCard,
        author: this.props.review.author,
        action: "opina",
        isUser: true,
        loggedIn: true
      })), React.createElement(Meta, null, React.createElement(Stars, {
        value: this.props.review.score
      }), React.createElement(PublishDate, null, "Publicado ", timeSince(new Date(review.revision.created)))), React.createElement(Body, null, isOwn ? !this.state.editing ? React.createElement(Fragment, null, React.createElement(EditButton, {
        handleClick: this.handleEditBtn
      }), React.createElement(DeleteButton, {
        handleClick: this.handleDeleteBtn
      })) : React.createElement(Fragment, null, React.createElement(SaveButton, {
        handleClick: this.handleSaveBtn
      }), React.createElement(CancelButton, {
        handleClick: this.handleCancelBtn
      })) : null, this.state.editing ? React.createElement(Fragment, null, React.createElement(ReviewTitle, {
        owned: isOwn
      }, this.props.review.title), React.createElement(Editor, {
        content: {
          type: 'plain',
          body: this.state.review.body.text
        },
        onUpdate: this.handleBodyUpdate
      })) : React.createElement(Fragment, null, React.createElement(ReviewTitle, {
        owned: isOwn
      }, this.state.title), React.createElement(EntryEditor, {
        readOnly: true,
        content: {
          type: 'plain',
          body: this.state.review.body.text
        },
        decorators: decorators
      }))), React.createElement(Features, null, this.props.review.features.map(function (feature, key) {
        var featureData = _this4.state.features.find(function (item) {
          return item.alias === feature.alias;
        });
        if (!featureData) {
          return React.createElement("div", {
            key: key
          });
        }
        return React.createElement(ReviewFeature, {
          key: key
        }, React.createElement(FeatureName, null, featureData.name), React.createElement(FeatureValue, null, React.createElement(Feature, {
          value: feature.score
        })));
      })), React.createElement(Footer, null, React.createElement(Toolbar, {
        like: {
          qty: this.state.likes,
          action: this.handleLike,
          done: liked,
          disable: isOwn ? 'No puedes realizar esta acción sobre tu propia review' : ''
        },
        respond: {
          qty: this.props.review.comments.length,
          path: path.superPartnerURL
        },
        share: {
          title: this.props.review.title,
          path: path.path
        }
      })), this.state.collapsed ? React.createElement(Fragment, null) : React.createElement(Comments, {
        review: this.props.review,
        qtyToShow: 3,
        me: this.props.me
      })));
    }
  }]);
  return ReviewCard;
}(React.Component);
export default React.memo(withTheme(ReviewCard));